import { MouseEvent, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EXCHANGE_MAPPING, AVAILABLE_EXCHANGES } from './helpers';
import { ECEXExchangeName } from '../../../../../reducers/cex_trading';
import { actionSetCurrentExchange } from '../../../../../actions/cex_trading';
import { IStore } from '../../../../../reducers';
import Text from '../../../../../atoms/Text';
import Image from '../../../../../atoms/Image';

import './styles.scss';

const ExchangeSelector = () => {
  const currentExchange = useSelector(
    (state: IStore) => state.cex_trading.currentExchange
  );
  const exchanges = useSelector((state: IStore) => state.cex_trading.exchanges);

  const [isMenuVisible, setMenuVisible] = useState(false);

  const dispatch = useDispatch();

  const onClick = (e: MouseEvent, exchange: ECEXExchangeName) => {
    e.stopPropagation();
    dispatch(actionSetCurrentExchange(exchange));
    setMenuVisible(false);
  };

  return (
    <div className='exchange_selector'>
      <div
        className='cex_wallet__api_list__exchange exchange_selector__selected'
        onClick={() => setMenuVisible(!isMenuVisible)}
      >
        <div className='cex_wallet__api_list__exchange__info'>
          <Image size='m' src={EXCHANGE_MAPPING[currentExchange].icon} />
          <Text size={14}>{EXCHANGE_MAPPING[currentExchange].label}</Text>
        </div>
        {/* {exchanges[currentExchange]?.enable ? ( */}
        <div className='cex_wallet__api_list__exchange__tick icon-check' />
        {/* ) : (
          <Text size={12} className='text--red-600 text--weight-500'>
            • not connected
          </Text>
        )} */}
      </div>
      {isMenuVisible && (
        <>
          <div
            className='exchange_selector__backdrop'
            onClick={() => setMenuVisible(false)}
          />
          <div className='exchange_selector__background'>
            <div className='exchange_selector__options'>
              {AVAILABLE_EXCHANGES.map((item) => (
                <div
                  key={item.value}
                  onClick={(e) => onClick(e, item.value)}
                  className={`exchange_selector__options__item ${
                    item.value === currentExchange
                      ? 'exchange_selector__options__item--active'
                      : ''
                  }`}
                >
                  <Image src={item.icon} size='m' />
                  <div className='exchange_selector__options__item__info'>
                    <Text size={12}>{item.label}</Text>
                    {!!exchanges[item.value]?.enable && (
                      <Text size={12} className='text--green-600'>
                        • connected
                      </Text>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ExchangeSelector;
